import { Mail, Phone, Users } from "lucide-react";
import HeroBreadcrumb from "@/components/layout/HeroBreadcrumb";

const AREE = [
  {
    titolo: "Direzione",
    slug: "direzione",
    persone: [
      {
        nome: "Romolo Guasco",
        ruolo: "Direttore",
        email: "direzione@confcommercioroma.it",
        tel: "06.68437501",
        foto: "/foto-guasco.png",
      },
    ],
  },
  {
    titolo: "Segreteria Generale",
    slug: "segreteria-generale",
    persone: [
      { nome: "Biancamaria Cerqua", ruolo: "Segreteria Presidenza", email: "presidenza@confcommercioroma.it", tel: "06.68437336" },
      { nome: "Marta Raponi", ruolo: "Segreteria Direzione", email: "direzione@confcommercioroma.it", tel: "06.68437500" },
    ],
  },
  {
    titolo: "Area Sviluppo Associativo, Marketing e Comunicazione",
    slug: "area-associativa-marketing-comunicazione",
    persone: [
      { nome: "Laura Ravazzoni", ruolo: "Responsabile Area Sviluppo Associativo, Marketing e Comunicazione", email: "l.ravazzoni@confcommercioroma.it", tel: "06.68437350 | 392.9236997" },
      { nome: "Barbara Di Cresce", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", email: "marketing@confcommercioroma.it", tel: "06.68437271 | 320.6481221" },
      { nome: "Emanuele Lucci", ruolo: "Comunicazione e Marketing", email: "social@confcommercioroma.it", tel: "06.68437270" },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Sviluppo Associativo, Marketing e Comunicazione", placeholder: true },
    ],
  },
  {
    titolo: "Area Lavoro e Welfare",
    slug: "ufficio-lavoro-e-welfare",
    persone: [
      { nome: "Francesca Bellini",   ruolo: "Responsabile Ufficio Lavoro e Welfare",  email: "sindacale@confcommercioroma.it",   tel: "06.68437221" },
      { nome: "Marco Caranzetti",    ruolo: "Relazioni Sindacali e Contenzioso",       email: "m.caranzetti@confcommercioroma.it", tel: "06.68437290" },
      { nome: "Dante Cucchi",        ruolo: "Conciliazione e Arbitrato",               email: "d.cucchi@confcommercioroma.it",     tel: "06.68437334" },
      { nome: "Valentina Russo",     ruolo: "Welfare Aziendale e Formazione",          email: "welfare@confcommercioroma.it",      tel: "06.68437238" },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Lavoro e Welfare", placeholder: true },
    ],
  },
  {
    titolo: "Area Legale, Legislativo, Relazioni Istituzionali e Organi Collegiali",
    slug: "area-legale-legislativo-relazioni-istituzionali",
    persone: [
      { nome: "Alessandro Ferretti", ruolo: "Responsabile Ufficio Legale",              email: "legale@confcommercioroma.it",  tel: "06.68437410" },
      { nome: "Chiara Moretti",      ruolo: "Consulenza Legale e Contrattualistica",    email: "legale2@confcommercioroma.it", tel: "06.68437411" },
    ],
  },
  {
    titolo: "Area Amministrativa",
    slug: "area-amministrativa",
    persone: [
      { nome: "Laura Bianchi",    ruolo: "Responsabile Amministrazione", email: "amministrazione@confcommercioroma.it", tel: "06.68437510" },
      { nome: "Stefano Romano",   ruolo: "Contabilità e Bilanci",         email: "contabilita@confcommercioroma.it",     tel: "06.68437511" },
      { nome: "Maria Pia Conti",  ruolo: "Risorse Umane",                 email: "risorseumane@confcommercioroma.it",    tel: "06.68437512" },
      { nome: "Nominativo in aggiornamento", ruolo: "Area Amministrativa", placeholder: true },
    ],
  },
];

function PersonaCard({ p }) {
  if (p.placeholder) {
    return (
      <div className="bg-white rounded-xl p-5 border border-dashed border-[var(--confcom-border)]" data-testid="persona-card-placeholder">
        <div className="w-full aspect-[4/3] rounded-lg mb-4 bg-[var(--confcom-bg-subtle)] flex items-center justify-center">
          <Users size={40} className="text-[var(--confcom-text-secondary)]/40" aria-hidden="true" />
        </div>
        <p className="font-semibold text-[var(--confcom-text-secondary)] font-['Encode_Sans_Semi_Condensed']">{p.nome}</p>
        <p className="text-sm text-[var(--confcom-text-secondary)]/70 font-medium mt-1">{p.ruolo}</p>
      </div>
    );
  }
  return (
    <div className="bg-white rounded-xl p-5 border border-[var(--confcom-border)]" data-testid="persona-card">
      {p.foto ? (
        <img
          src={p.foto}
          alt={`${p.nome}, ${p.ruolo} di Confcommercio Roma`}
          className="w-full rounded-lg mb-4 aspect-[4/3] object-cover object-top"
        />
      ) : (
        <div className="w-full aspect-[4/3] rounded-lg mb-4 bg-[var(--confcom-bg-blue-light)] flex items-center justify-center">
          <Users size={56} className="text-[var(--confcom-blue)]/60" aria-hidden="true" />
        </div>
      )}
      <p className="font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed']">{p.nome}</p>
      <p className="text-sm text-[var(--confcom-blue)] font-medium mt-1 mb-3">{p.ruolo}</p>
      <div className="space-y-1.5">
        <a
          href={`mailto:${p.email}`}
          className="flex items-center gap-2 text-xs text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)] transition-colors"
        >
          <Mail size={13} className="shrink-0" aria-hidden="true" /> {p.email}
        </a>
        <a
          href={`tel:${p.tel.split("|")[0].replace(/[^0-9+]/g, "")}`}
          className="flex items-center gap-2 text-xs text-[var(--confcom-text-secondary)] hover:text-[var(--confcom-blue)] transition-colors"
        >
          <Phone size={13} className="shrink-0" aria-hidden="true" /> {p.tel}
        </a>
      </div>
    </div>
  );
}

export default function StrutturaTecnicaPage() {
  return (
    <main id="main-content" data-testid="struttura-tecnica-page">
      {/* Hero */}
      <section className="bg-[var(--confcom-blue)] py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <HeroBreadcrumb />
          <h1 className="text-4xl md:text-5xl font-bold text-white font-['Encode_Sans_Semi_Condensed'] tracking-tight">
            Struttura Tecnica
          </h1>
        </div>
      </section>

      {/* Aree */}
      {AREE.map((area, idx) => (
        <section
          key={area.slug}
          id={area.slug}
          className={`py-14 ${idx % 2 === 1 ? "bg-[var(--confcom-bg-subtle)]" : "bg-white"}`}
          data-testid={`area-${area.slug}`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-[var(--confcom-text-primary)] font-['Encode_Sans_Semi_Condensed'] mb-8">
              {area.titolo}
            </h2>
            {area.sottogruppi ? (
              <div>
                {area.sottogruppi.map((gruppo) => (
                  <div key={gruppo.nome} className="mb-16">
                    <h3 className="text-base font-bold text-[var(--confcom-blue)] uppercase tracking-wide font-['Encode_Sans_Semi_Condensed'] mb-4">
                      {gruppo.nome}
                    </h3>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                      {gruppo.persone.map((p, i) => (
                        <PersonaCard key={`${gruppo.nome}-${i}`} p={p} />
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
                {area.persone.map((p, i) => (
                  <PersonaCard key={`${area.slug}-${i}`} p={p} />
                ))}
              </div>
            )}
          </div>
        </section>
      ))}
    </main>
  );
}
